import { concatMap, tap, map } from 'rxjs/operators';
import { CrudServiceBase, RxUtils, TypeUtils } from '@utils';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { FleetVehicle } from './fleet-vehicle.class';
import { VehicleStatus } from './vehicle-status.enum';
import { BulkSelect } from './bulk-select.class';

type Entity = FleetVehicle;

export class FleetVehicleService extends CrudServiceBase<Entity> {
	constructor() {
		super(FleetVehicle, 'fleet-vehicle');
	}

	getByStatus(status: VehicleStatus) {
		return httpService.get<FleetVehicle[]>(this.getUrl(), `status/${status}`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getByStatus.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((vehicles) => TypeUtils.convert(FleetVehicle, vehicles))
		);
	}

	selectSolution(vehicleId: string, selectedCarModelId: number) {
		return httpService
			.patch<FleetVehicle>(this.getUrl(), `selected/${vehicleId}`, { body: { selectedCarModelId }, errorHandler: 'notification' })
			.pipe(
				tap((result) => logger.debug(`[${this.constructor.name}.${this.selectSolution.name}]`, result)),
				concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
				map((result) => TypeUtils.convert(FleetVehicle, result))
			);
	}

	selectSolutions(bulkSelect: BulkSelect[]) {
		return httpService.patch<unknown>(this.getUrl(), 'bulk/select', { body: bulkSelect, errorHandler: 'notification' }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.selectSolutions.name}]`, result)),
			map(() => 'success'),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty')))
		);
	}
}

export const fleetVehicleService = new FleetVehicleService();
